import { toNumber } from 'lodash'
import capitalize from '@/utils/capitalize'
import {
  getCampaignDeeplink,
  getListingTypeText,
  streetName,
  formatListingAddress,
  unitHidden,
  getFurnished,
  renderAvailability,
  getBedrooms,
  formatFee
} from './share-functions.js'

const getBathrooms = listing => {
  if (listing.unit_type_scope_txt_id === 'entire')
    return `- ${parseFloat(listing.count_all_bathrooms)} bathroom\n`
  const fullBath =
    toNumber(listing.count_full_shared_bathrooms) > 0
      ? `- ${parseFloat(listing.count_full_bathrooms)} private bathroom\n`
      : ''
  const privateBath =
    toNumber(listing.count_full_shared_bathrooms) > 0
      ? `- ${parseFloat(listing.count_full_shared_bathrooms)} shared bathroom\n`
      : ''
  return `${fullBath}${privateBath}`
}

const getDenFlex = listing =>
  toNumber(listing.count_dens) > 0 ? `- ${listing.count_dens} den/flex\n` : ''

const formatAmenities = (features, customFeatures, unitType) => {
  const combinedFeatures = [...features, ...customFeatures]
  const featuresArray = combinedFeatures.map(item => {
    let featureText = [item.name]
    if (unitType !== 'entire') {
      featureText.push(`(${item.type})`)
    }
    return `- ${featureText.join(' ')}\n`
  })
  return featuresArray.join('')
}

const CopyListingKijiji = async (listing, areaMeasurementUnit) => {
  const listingUrl = await getCampaignDeeplink('kijiji', listing.listing_id)

  return `**Message or Apply Now at ${listingUrl}**

${getListingTypeText(listing.unit_type_txt_id, listing.unit_type_scope_txt_id)} ${
    !unitHidden(listing) ? `Unit ${listing.unit_number} ` : ''
  }at ${formatListingAddress(listing)}

Unit Details:
- ${getBedrooms(listing, areaMeasurementUnit)}
${getBathrooms(listing)}${getDenFlex(listing)}${
    listing.unit_type_scope_txt_id === 'single' ? '' : `- Size: ${listing.size} sqft\n`
  }- ${getFurnished(listing)}

Rental Terms and Conditions:
${listing.max_occupancy > 0 ? `- Max. occupancy: ${listing.max_occupancy}\n` : ''}- Pets: ${
    listing.allow_pets ? 'Yes' : 'No'
  }
- Smoking: ${listing.allow_smoking ? 'Yes' : 'No'}
- Lease Type: ${capitalize(listing.lease_type).replace(/_/g, ' ')}
- Available date: ${renderAvailability(listing)}
${listing.description && `\nAbout This Property:\n${listing.description}\n`}
Amenities:
${formatFee(listing.parking, 'Parking') ? `- ${formatFee(listing.parking, 'Parking')}\n` : ''}${
    formatFee(listing.storage, 'Storage') ? `- ${formatFee(listing.storage, 'Storage')}\n` : ''
  }${formatAmenities(
    listing.unit_features,
    listing.custom_features,
    listing.unit_type_scope_txt_id
  )}${formatAmenities(
    listing.listing_utilities,
    listing.custom_utilities,
    listing.unit_type_scope_txt_id
  )}
About the Building:
- Address: ${streetName(listing)}
- Neighborhood: ${listing.building.neighborhood || listing.building.city}
`
}

export default CopyListingKijiji
